import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  variant?: 'light' | 'dark';
  showText?: boolean;
  heightClassName?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', variant = 'dark', showText = true, heightClassName }) => {
  const heightMap = {
    sm: 108,
    md: 120,
    lg: 150,
    xl: 180,
    '2xl': 220,
  };

  const logoHeight = heightMap[size];

  // dark variant = purple text logo (for white/light backgrounds)
  // light variant = white text logo (for dark/purple backgrounds)
  const logoSrc = variant === 'light' ? '/logo-light.png' : '/logo-dark.jpg';

  return (
    <div className="flex items-center">
      <img
        src={logoSrc} 
        alt="Future Minds Academy" 
        className={heightClassName}
        style={{
          height: heightClassName ? undefined : `${logoHeight}px`,
          width: 'auto',
          objectFit: 'contain',
        }}
      />
    </div>
  );
};

export default Logo;
